// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  fragment contactFormEntryFragment on ContactFormEntry {
    _id
    createdAt
    clientId
    firstName
    lastName
    email
    phone
    message
    venue
    eventType
    eventDate
    whereDidYouHearAboutUs
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/contactFormEntryFragment.js